import { wrap as withStyle } from 'utils/styles'

export default withStyle((props) => {
  const { inactiveTabTextColor, activeTabBackground } = props.theme
  return `
    && {
      .ant-tabs-nav .ant-tabs-tab {
        color: ${inactiveTabTextColor};
      }
    
      .ant-tabs-ink-bar{
        background-color: ${activeTabBackground};
        height: 4px;
      }
    .
    }
  `
})
